import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import resourcesToBackend from 'i18next-resources-to-backend';

import ru from './locales/ru/translation.json';

const SUPPORTED_LANGUAGES = ['ru', 'en', 'de', 'fr', 'es', 'it', 'pt', 'pl', 'tr', 'zh'];

i18n
    .use(LanguageDetector)
    .use(resourcesToBackend((lng, ns) => import(`./locales/${lng}/${ns}.json`)))
    .use(initReactI18next)
    .init({
        resources: { ru: { translation: ru } },
        partialBundledLanguages: true,
        fallbackLng: 'ru',
        supportedLngs: SUPPORTED_LANGUAGES,
        detection: {
            order: ['localStorage'],
            caches: ['localStorage'],
            lookupLocalStorage: 'pixel_language',
        },
        interpolation: {
            escapeValue: false,
        },
    });

export const LANGUAGES = [
    { code: 'ru', label: 'Русский' },
    { code: 'en', label: 'English' },
    { code: 'de', label: 'Deutsch' },
    { code: 'fr', label: 'Français' },
    { code: 'es', label: 'Español' },
    { code: 'it', label: 'Italiano' },
    { code: 'pt', label: 'Português' },
    { code: 'pl', label: 'Polski' },
    { code: 'tr', label: 'Türkçe' },
    { code: 'zh', label: '中文' },
];

export default i18n;